module.exports = __webpack_public_path__ + "static/media/AoA_CloseUp_4.80285ac3.jpg";